var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.$store.state.userCurrentCompany)?_c('div',{staticClass:"iframe-container"},[_c('iframe',{attrs:{"src":this.dashboardUrl,"id":"dashboard-frame","width":"1200px","height":"850px","allowfullscreen":"","frameborder":"0"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }